import API from 'app/utils/apiClient';
import { toParams } from 'app/utils/url';

const getPopularTags = (withProtected = true, page = 1, perPage = 10) => {
  const params = toParams({
    withProtected,
    page,
    perPage,
  });
  return API.get(`/popular-tags/?${params}`);
};

const getStoriesByTag = (id, ordering, page = 1, perPage = 20) => {
  const params = toParams({
    page,
    perPage,
    ordering,
  });
  return API.get(`/tags/${id}/stories/?${params}`);
};

const getRecommendedTags = () => API.get('/recommended-tags/');

const getTagRanking = () => API.get('/ranking/tags/');

const createTag = (name) => API.post('/tags/', { name });

export default {
  getPopularTags,
  getStoriesByTag,
  getRecommendedTags,
  getTagRanking,
  createTag,
};



// WEBPACK FOOTER //
// ./src/app/apis/tag.js